import React, { useState } from 'react';
import styled from 'styled-components';
import { useClosePopup } from '../../../utils/hooks/usePopup';
import Popup from '../../Popup';
import Button from '../../../elements/Button';
import sha256 from 'sha256';
import API from '../../../utils/api/API';

export default function VerifyUser({ user, uid, onConfirm }) {
	const close = useClosePopup();

	const [password, setPassword] = useState();

	const confirm = async () => {
		if (!user && !uid) alert('ChangePassword error, neither "user" or "uid" parameters found!');

		// Update password
		await API.put(`/users/${user ? user.id : uid}`, { verified: true }, true); // nått fel här på id undefined
		onConfirm && onConfirm();
		close();
	};

	return (
		<Popup close={close} width="40em" maxWidth="25em">
			<Style>
				<h2 className="title">Verifiera användare</h2>
				<div className="spacer s"></div>
				<p>Denna användare har inte verifierat sitt konto själv vilket kan tyda på att telefonnummret är ogiltigt!</p>
				<br />
				<p>Genom att verifiera så tillåts användaren använda systemet som en vanlig användare!</p>


				<div className="buttons">
					<Button type="secondary" onClick={close}>
						Avbryt
					</Button>
					<Button onClick={confirm}>Verifiera</Button>
				</div>
			</Style>
		</Popup>
	);
}

const Style = styled.div``;
